"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.STATUS_MAP = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _getImportantRespondentFields = _interopRequireDefault(require("../../../helpers/getImportantRespondentFields.js"));
var _languageColumn = _interopRequireDefault(require("../../../helpers/languageColumn.js"));
var _admin = require("../../../selectors/admin.js");
var _respondentsByDeployment_identifiable = _interopRequireDefault(require("./respondentsByDeployment_identifiable.graphql"));
var _respondentsByDeployment_noIdentifiable = _interopRequireDefault(require("./respondentsByDeployment_noIdentifiable.graphql"));
var _respondentsByGroup_identifiable = _interopRequireDefault(require("./respondentsByGroup_identifiable.graphql"));
var _respondentsByGroup_noIdentifiable = _interopRequireDefault(require("./respondentsByGroup_noIdentifiable.graphql"));
var _respondentsFromResponses_identifiable = _interopRequireDefault(require("./respondentsFromResponses_identifiable.graphql"));
var _respondentsFromResponses_noIdentifiable = _interopRequireDefault(require("./respondentsFromResponses_noIdentifiable.graphql"));
var _flagRespondentsByDeployment_identifiable = _interopRequireDefault(require("./flagRespondentsByDeployment_identifiable.graphql"));
var _flagRespondentsByDeployment_noIdentifiable = _interopRequireDefault(require("./flagRespondentsByDeployment_noIdentifiable.graphql"));
var _flagRespondentsByGroup_identifiable = _interopRequireDefault(require("./flagRespondentsByGroup_identifiable.graphql"));
var _flagRespondentsByGroup_noIdentifiable = _interopRequireDefault(require("./flagRespondentsByGroup_noIdentifiable.graphql"));
var _flagRespondentsFromResponses_identifiable = _interopRequireDefault(require("./flagRespondentsFromResponses_identifiable.graphql"));
var _flagRespondentsFromResponses_noIdentifiable = _interopRequireDefault(require("./flagRespondentsFromResponses_noIdentifiable.graphql"));
var _index = _interopRequireDefault(require("../CertificateRender/index.js"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _ClearProgressAndMetrics = _interopRequireDefault(require("./ClearProgressAndMetrics"));
var _ToggleFlagForm = _interopRequireDefault(require("./ToggleFlagForm.js"));
var _NoteForm = _interopRequireDefault(require("./NoteForm.js"));
var _FlagHistory = _interopRequireDefault(require("./FlagHistory.js"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AppDefs = window.cccisd.appDefs;
var Fortress = window.cccisd.fortress;
var STATUS_MAP = exports.STATUS_MAP = ['Not Started', 'In Progress', 'Completed'];
var AssignmentStatusTable = /*#__PURE__*/function (_React$Component) {
  function AssignmentStatusTable() {
    var _this;
    _classCallCheck(this, AssignmentStatusTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AssignmentStatusTable, [].concat(args));
    _defineProperty(_this, "state", {
      isLoading: true,
      assignmentProgressPath: '',
      pawnIdPath: '',
      rowKeyPath: '',
      userPath: '',
      query: '',
      variables: {},
      columns: [],
      deploymentType: null,
      closedRoster: null,
      roleHandles: [],
      selectedRows: [],
      selectedData: {}
    });
    /* /////////////////////////////////////////////////////////////////////////
    // GENERAL METHODS ////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
    _defineProperty(_this, "canSeeIdentifiable", function () {
      var assignment = _this.props.assignment;
      return Fortress.hasAccess('quest.view_identifiable_data', assignment.groupId);
    });
    _defineProperty(_this, "setDeploymentParams", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _this$props, projectDeployments, currentDeploymentIds, selectedDeployment;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.setState({
              isLoading: true
            });
          case 1:
            _this$props = _this.props, projectDeployments = _this$props.projectDeployments, currentDeploymentIds = _this$props.currentDeploymentIds;
            if (currentDeploymentIds.length) {
              _context.n = 2;
              break;
            }
            _this.setState({
              isLoading: false
            });
            return _context.a(2);
          case 2:
            selectedDeployment = projectDeployments.find(function (item) {
              return !item.archived && currentDeploymentIds[0] === item.deploymentId;
            });
            if (selectedDeployment) {
              _context.n = 3;
              break;
            }
            _this.setState({
              isLoading: false
            });
            return _context.a(2);
          case 3:
            _context.n = 4;
            return _this.setState({
              deploymentType: selectedDeployment.type,
              closedRoster: selectedDeployment.settings.closedRoster,
              parentDeploymentId: selectedDeployment.parentDeploymentId,
              roleHandles: [selectedDeployment.roleHandle]
            });
          case 4:
            _context.n = 5;
            return _this.setGraphQLParams();
          case 5:
            _context.n = 6;
            return _this.setGraphQLColumns();
          case 6:
            return _context.a(2);
        }
      }, _callee);
    })));
    _defineProperty(_this, "selectedDeploymentId", function () {
      return _this.props.overrideDeploymentIds || (_this.props.currentDeploymentIds.length ? _this.props.currentDeploymentIds[0] : 0);
    });
    _defineProperty(_this, "setGraphQLParams", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _this$props2, assignment, pawnIdWhitelist, flagId, _this$state, deploymentType, closedRoster, roleHandles, parentDeploymentId, canSeeIdentifiable, assignmentProgressPath, pawnIdPath, rowKeyPath, userPath, query, deploymentId, variables, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _this$props2 = _this.props, assignment = _this$props2.assignment, pawnIdWhitelist = _this$props2.pawnIdWhitelist, flagId = _this$props2.flagId;
            _this$state = _this.state, deploymentType = _this$state.deploymentType, closedRoster = _this$state.closedRoster, roleHandles = _this$state.roleHandles, parentDeploymentId = _this$state.parentDeploymentId;
            canSeeIdentifiable = _this.canSeeIdentifiable();
            assignmentProgressPath = 'assignmentProgress.';
            pawnIdPath = flagId ? 'assignmentProgress.pawn.pawn.' : 'pawn.';
            rowKeyPath = flagId ? 'flagProgressId' : 'pawn.pawnId';
            userPath = flagId ? 'assignmentProgress.pawn.' : '';
            query = canSeeIdentifiable ? _respondentsByGroup_identifiable["default"] : _respondentsByGroup_noIdentifiable["default"];
            if (flagId) {
              query = canSeeIdentifiable ? _flagRespondentsByGroup_identifiable["default"] : _flagRespondentsByGroup_noIdentifiable["default"];
            }
            deploymentId = _this.selectedDeploymentId();
            variables = _objectSpread({
              deploymentId: deploymentId,
              roleHandle: _this.props.roleHandles || roleHandles
            }, flagId ? {
              flagId: flagId
            } : {});
            _t = deploymentType;
            _context2.n = _t === 'anon' ? 1 : _t === 'known' ? 2 : _t === 'group' ? 3 : 4;
            break;
          case 1:
            assignmentProgressPath = flagId ? 'assignmentProgress.' : '';
            pawnIdPath = flagId ? 'assignmentProgress.pawn.pawn.' : '';
            rowKeyPath = flagId ? 'flagProgressId' : 'assignmentProgressId';
            userPath = flagId ? 'assignmentProgress.pawn.' : 'pawn.';
            query = canSeeIdentifiable ? _respondentsFromResponses_identifiable["default"] : _respondentsFromResponses_noIdentifiable["default"];
            if (flagId) {
              query = canSeeIdentifiable ? _flagRespondentsFromResponses_identifiable["default"] : _flagRespondentsFromResponses_noIdentifiable["default"];
            }
            variables = _objectSpread({
              deploymentId: deploymentId
            }, flagId ? {
              flagId: flagId
            } : {});
            return _context2.a(3, 5);
          case 2:
            assignmentProgressPath = flagId ? 'assignmentProgress.' : 'pawn.assignmentProgress.';
            pawnIdPath = flagId ? 'assignmentProgress.pawn.pawn.' : 'pawn.pawn.';
            rowKeyPath = flagId ? 'flagProgressId' : 'pawn.pawn.pawnId';
            userPath = flagId ? 'assignmentProgress.pawn.' : 'pawn.';
            query = canSeeIdentifiable ? _respondentsByDeployment_identifiable["default"] : _respondentsByDeployment_noIdentifiable["default"];
            if (flagId) {
              query = canSeeIdentifiable ? _flagRespondentsByDeployment_identifiable["default"] : _flagRespondentsByDeployment_noIdentifiable["default"];
            }
            variables = _objectSpread({
              // Get respondents list from Parent, but get Progress from Child.
              // If not repeatable, get both respondents and progress from same deployment.
              childDeploymentId: deploymentId,
              parentDeploymentId: parentDeploymentId || deploymentId
            }, flagId ? {
              flagId: flagId
            } : {});
            return _context2.a(3, 5);
          case 3:
            if (closedRoster) {
              assignmentProgressPath = flagId ? 'assignmentProgress.' : 'pawn.assignmentProgress.';
              pawnIdPath = flagId ? 'assignmentProgress.pawn.pawn.' : 'pawn.pawn.';
              rowKeyPath = flagId ? 'flagProgressId' : 'pawn.pawn.pawnId';
              userPath = flagId ? 'assignmentProgress.pawn.' : 'pawn.';
              query = canSeeIdentifiable ? _respondentsByDeployment_identifiable["default"] : _respondentsByDeployment_noIdentifiable["default"];
              if (flagId) {
                query = canSeeIdentifiable ? _flagRespondentsByDeployment_identifiable["default"] : _flagRespondentsByDeployment_noIdentifiable["default"];
              }
              variables = _objectSpread({
                // Get respondents list from Parent, but get Progress from Child.
                // If not repeatable, get both respondents and progress from same deployment.
                childDeploymentId: deploymentId,
                parentDeploymentId: parentDeploymentId || deploymentId
              }, flagId ? {
                flagId: flagId
              } : {});
            }
            return _context2.a(3, 5);
          case 4:
            return _context2.a(3, 5);
          case 5:
            variables.projectId = assignment.groupId;
            variables.pawnIds = pawnIdWhitelist;
            _context2.n = 6;
            return _this.setState({
              assignmentProgressPath: assignmentProgressPath,
              pawnIdPath: pawnIdPath,
              rowKeyPath: rowKeyPath,
              userPath: userPath,
              query: query,
              variables: variables
            });
          case 6:
            return _context2.a(2);
        }
      }, _callee2);
    })));
    _defineProperty(_this, "setGraphQLColumns", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var _assignment$settings$, _assignment$settings$2, _assignment$settings$3, _assignment$settings$4, _assignment$settings$5;
      var _this$props3, assignment, project, showBy, hideSystemId, setColumnDefinitions, flagId, hideResolveAction, _this$state2, assignmentProgressPath, deploymentType, pawnIdPath, userPath, roleHandles, canSeeIdentifiable, appdefRoles, columns, roleDefs, _iterator, _step, roleDef, importantFields, _iterator2, _step2, f, roleFilterOptions, hasFinalTest, isCourseWrapper, certificateToggle, finalColumns, _t2, _t3, _t4;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            _this$props3 = _this.props, assignment = _this$props3.assignment, project = _this$props3.project, showBy = _this$props3.showBy, hideSystemId = _this$props3.hideSystemId, setColumnDefinitions = _this$props3.setColumnDefinitions, flagId = _this$props3.flagId, hideResolveAction = _this$props3.hideResolveAction;
            _this$state2 = _this.state, assignmentProgressPath = _this$state2.assignmentProgressPath, deploymentType = _this$state2.deploymentType, pawnIdPath = _this$state2.pawnIdPath, userPath = _this$state2.userPath, roleHandles = _this$state2.roleHandles;
            canSeeIdentifiable = _this.canSeeIdentifiable();
            appdefRoles = AppDefs.pawn.roles || [];
            columns = [];
            if (flagId) {
              columns.push({
                name: 'flagName',
                label: 'Name',
                className: 'text-nowrap',
                render: function render(_ref4) {
                  var value = _ref4.value,
                    row = _ref4.row;
                  var description = row["flag.description"];
                  if (!description) {
                    return row["flag.name"];
                  }
                  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
                    style: {
                      marginRight: '0.3em'
                    }
                  }, row["flag.name"]), /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
                    title: description
                  }, /*#__PURE__*/_react["default"].createElement("span", {
                    className: "text-primary"
                  }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))));
                },
                topHeader: 'Flag',
                topHeaderSpan: 4,
                filter: true
              });
              columns.push({
                name: 'flagDate',
                label: 'Date flagged',
                className: 'text-nowrap',
                render: function render(_ref5) {
                  var value = _ref5.value,
                    row = _ref5.row;
                  var date = row.flaggedAt;
                  return date ? (0, _format["default"])(new Date(date), 'MM/dd/yyyy h:mm a') : null;
                }
              });
              columns.push({
                name: 'flagStatus',
                label: 'Status',
                render: function render(_ref6) {
                  var value = _ref6.value,
                    row = _ref6.row,
                    loadData = _ref6.loadData;
                  if (row.status === 'flagged') {
                    return /*#__PURE__*/_react["default"].createElement("span", {
                      className: "badge bg-danger"
                    }, "Unresolved");
                  }
                  return /*#__PURE__*/_react["default"].createElement("span", {
                    className: "badge bg-success"
                  }, "Resolved");
                }
              });
              columns.push({
                name: 'flagActions',
                label: 'Actions',
                className: 'text-center',
                render: function render(_ref7) {
                  var _row$log;
                  var value = _ref7.value,
                    row = _ref7.row,
                    loadData = _ref7.loadData;
                  var actions = [];
                  var unresolved = row.status === 'flagged';
                  var haveLogs = ((_row$log = row.log) === null || _row$log === void 0 ? void 0 : _row$log.length) > 0;

                  // Resolve/Undo
                  !hideResolveAction && actions.push(/*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
                    key: "resolve/undo",
                    title: unresolved ? 'Resolve flag' : 'Undo flag resolution',
                    trigger: /*#__PURE__*/_react["default"].createElement("button", {
                      type: "button",
                      className: "btn btn-xs btn-secondary"
                    }, unresolved ? 'Resolve' : 'Undo')
                  }, /*#__PURE__*/_react["default"].createElement(_ToggleFlagForm["default"], {
                    flagProgressId: row.flagProgressId,
                    flagStatus: row.status,
                    onSubmit: loadData
                  })));

                  // Note
                  actions.push(/*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
                    key: "note",
                    title: "Add note",
                    trigger: /*#__PURE__*/_react["default"].createElement("button", {
                      type: "button",
                      className: "btn btn-xs btn-secondary"
                    }, "Note")
                  }, /*#__PURE__*/_react["default"].createElement(_NoteForm["default"], {
                    flagProgressId: row.flagProgressId,
                    flagStatus: row.status,
                    onSubmit: loadData
                  })));

                  // Logs
                  if (!haveLogs) {
                    actions.push(/*#__PURE__*/_react["default"].createElement("button", {
                      key: "noLogs",
                      type: "button",
                      className: "btn btn-secondary btn-xs",
                      disabled: true
                    }, "Logs"));
                  } else {
                    actions.push(/*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
                      key: "logs",
                      title: "Flag logs",
                      trigger: /*#__PURE__*/_react["default"].createElement("button", {
                        type: "button",
                        className: "btn btn-xs btn-secondary"
                      }, "Logs"),
                      size: "large"
                    }, /*#__PURE__*/_react["default"].createElement(_FlagHistory["default"], {
                      history: row.log
                    })));
                  }
                  return /*#__PURE__*/_react["default"].createElement("div", {
                    style: {
                      display: 'flex',
                      gap: '0.3em'
                    }
                  }, actions);
                }
              });
            }

            // System ID Column
            if (!hideSystemId) {
              columns.push({
                name: "".concat(pawnIdPath, "pawnId"),
                label: 'System ID',
                sort: true,
                filter: true
              });
            }
            roleDefs = appdefRoles.filter(function (item) {
              return (_this.props.roleHandles || roleHandles).includes(item.handle);
            }); // Important Fields columns (roles.json)
            _iterator = _createForOfIteratorHelper(roleDefs);
            _context3.p = 1;
            _iterator.s();
          case 2:
            if ((_step = _iterator.n()).done) {
              _context3.n = 11;
              break;
            }
            roleDef = _step.value;
            importantFields = roleDef.importantFields || [];
            if (roleDef.handle === 'respondent') {
              importantFields = (0, _getImportantRespondentFields["default"])({
                importantFields: importantFields,
                project: project
              });
            }
            _iterator2 = _createForOfIteratorHelper(importantFields);
            _context3.p = 3;
            _iterator2.s();
          case 4:
            if ((_step2 = _iterator2.n()).done) {
              _context3.n = 7;
              break;
            }
            f = _step2.value;
            if (!(!canSeeIdentifiable && f.identifiable)) {
              _context3.n = 5;
              break;
            }
            return _context3.a(3, 6);
          case 5:
            columns.push({
              name: "".concat(userPath, "important.").concat(f.path),
              label: f.label,
              sort: true,
              filter: true
            });
          case 6:
            _context3.n = 4;
            break;
          case 7:
            _context3.n = 9;
            break;
          case 8:
            _context3.p = 8;
            _t2 = _context3.v;
            _iterator2.e(_t2);
          case 9:
            _context3.p = 9;
            _iterator2.f();
            return _context3.f(9);
          case 10:
            _context3.n = 2;
            break;
          case 11:
            _context3.n = 13;
            break;
          case 12:
            _context3.p = 12;
            _t3 = _context3.v;
            _iterator.e(_t3);
          case 13:
            _context3.p = 13;
            _iterator.f();
            return _context3.f(13);
          case 14:
            // ----------------------------------------------

            // Anon deployment role column
            if (deploymentType === 'anon') {
              roleFilterOptions = appdefRoles.map(function (p) {
                return {
                  label: p.label,
                  value: p.handle
                };
              });
              columns.push({
                name: "".concat(pawnIdPath, "role"),
                label: 'Role',
                sort: true,
                filter: true,
                filterSettings: {
                  type: 'selectbox',
                  options: roleFilterOptions
                },
                render: function render(_ref8) {
                  var value = _ref8.value;
                  var roleDef = appdefRoles.find(function (r) {
                    return r.handle === value;
                  });
                  return roleDef ? roleDef.label : value;
                }
              });
            }
            // ---------------------------------------------------

            columns = (0, _uniqBy2["default"])(columns, 'name');

            // Languages column
            if (assignment.settings.languages.length > 1) {
              columns.push((0, _languageColumn["default"])({
                name: "".concat(assignmentProgressPath, "language")
              }));
            }

            // Survey List
            if (assignment.surveylistList.length > 1) {
              columns.push({
                name: "".concat(assignmentProgressPath, "flowList"),
                label: 'Surveylist',
                sort: true,
                filter: true
              });
            }
            hasFinalTest = ((_assignment$settings$ = assignment.settings.navigationSettings) === null || _assignment$settings$ === void 0 ? void 0 : _assignment$settings$.finalTest) && ((_assignment$settings$2 = assignment.settings.navigationSettings.finalTest) === null || _assignment$settings$2 === void 0 ? void 0 : _assignment$settings$2.toggle);
            isCourseWrapper = (_assignment$settings$3 = assignment.settings.navigation) === null || _assignment$settings$3 === void 0 ? void 0 : _assignment$settings$3.includes('courseWrapper');
            certificateToggle = ((_assignment$settings$4 = assignment.settings.navigationSettings) === null || _assignment$settings$4 === void 0 ? void 0 : _assignment$settings$4.certificate) && ((_assignment$settings$5 = assignment.settings.navigationSettings) === null || _assignment$settings$5 === void 0 ? void 0 : _assignment$settings$5.certificate.toggle);
            _t4 = showBy;
            _context3.n = _t4 === 'assignment' ? 15 : _t4 === 'module' ? 16 : _t4 === 'survey' ? 17 : 18;
            break;
          case 15:
            // Status / Certificate Columns
            _this.addAssignmentStatusColumns(columns);
            if (isCourseWrapper && certificateToggle) {
              _this.addCertificateColumn(columns);
            }
            if (hasFinalTest) {
              _this.addScoreDuration(columns);
            }
            return _context3.a(3, 19);
          case 16:
            _this.addModuleStatusColumns(columns);
            return _context3.a(3, 19);
          case 17:
            _this.addSurveyStatusColumns(columns);
            return _context3.a(3, 19);
          case 18:
            return _context3.a(3, 19);
          case 19:
            finalColumns = setColumnDefinitions ? setColumnDefinitions(columns) : columns;
            _context3.n = 20;
            return _this.setState({
              columns: finalColumns,
              isLoading: false
            });
          case 20:
            return _context3.a(2);
        }
      }, _callee3, null, [[3, 8, 9, 10], [1, 12, 13, 14]]);
    })));
    /* /////////////////////////////////////////////////////////////////////////
    // COLUMN HELPERS /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
    _defineProperty(_this, "addScoreDuration", function (columns) {
      var assignmentProgressPath = _this.state.assignmentProgressPath;
      columns.push({
        name: "".concat(assignmentProgressPath, "variables"),
        label: 'Score',
        className: 'text-center',
        hideInCsv: true,
        render: function render(_ref9) {
          var value = _ref9.value,
            row = _ref9.row;
          var assignmentHandle = row['assignmentProgress.assignmentHandle'];
          var testScore = row["assignmentProgress.variables.".concat(assignmentHandle, "_test_score")];
          if (!testScore) {
            return null;
          }
          return /*#__PURE__*/_react["default"].createElement("div", null, testScore);
        }
      });
      columns.push({
        name: "".concat(assignmentProgressPath, "assignmentHandle"),
        label: 'Duration',
        className: 'text-center',
        hideInCsv: true,
        render: function render(_ref0) {
          var value = _ref0.value,
            row = _ref0.row;
          var assignmentHandle = row['assignmentProgress.assignmentHandle'];
          var duration = row["assignmentProgress.variables.".concat(assignmentHandle, "_duration")];
          if (!duration) {
            return null;
          }
          var hours = Math.floor(duration / 3600);
          var minusHours = duration - hours * 3600;
          var minutes = Math.floor(minusHours / 60);
          var seconds = minusHours - minutes * 60;
          var strPadLeft = function strPadLeft(string, pad, length) {
            return (new Array(length + 1).join(pad) + string).slice(-length);
          };
          var finalTime = strPadLeft(hours, '0', 2) + ':' + strPadLeft(minutes, '0', 2) + ':' + strPadLeft(seconds, '0', 2);
          return /*#__PURE__*/_react["default"].createElement("div", null, finalTime);
        }
      });
    });
    _defineProperty(_this, "addAssignmentStatusColumns", function (columns) {
      var assignment = _this.props.assignment;
      var _this$state3 = _this.state,
        userPath = _this$state3.userPath,
        assignmentProgressPath = _this$state3.assignmentProgressPath;
      columns.push({
        name: "".concat(assignmentProgressPath, "lastVisitedAt"),
        label: 'Last Visited',
        sort: true,
        filter: true,
        filterSettings: {
          type: 'date'
        }
      });
      columns.push({
        name: "".concat(userPath, "assignmentProgressStatus.assignment").concat(assignment.assignmentId),
        label: 'Status',
        sort: true,
        filter: true,
        filterSettings: {
          type: 'selectbox',
          placeholder: '-- Choose one --',
          options: [{
            label: STATUS_MAP[0],
            value: 0
          }, {
            label: STATUS_MAP[1],
            value: 1
          }, {
            label: STATUS_MAP[2],
            value: 2
          }]
        },
        render: function render(_ref1) {
          var value = _ref1.value,
            row = _ref1.row;
          if (value > 0) {
            // let key = `assignmentProgressStatus.assignment${assignment.assignmentId}_lastVisit`;
            return /*#__PURE__*/_react["default"].createElement("div", null, STATUS_MAP[Number.parseInt(value, 10)]);
          }
          return STATUS_MAP[0];
        }
      });
      columns.push({
        name: "".concat(assignmentProgressPath, "completedAt"),
        label: 'Completed At',
        sort: true,
        filter: true,
        filterSettings: {
          type: 'date'
        }
      });
    });
    _defineProperty(_this, "addCertificateColumn", function (columns) {
      var _this$state4 = _this.state,
        deploymentType = _this$state4.deploymentType,
        userPath = _this$state4.userPath,
        pawnIdPath = _this$state4.pawnIdPath;
      var deploymentId = _this.state.variables.deploymentId || _this.state.variables.childDeploymentId;
      var deployment = _this.props.currentDeployments.find(function (item) {
        return item.deploymentId === deploymentId;
      });
      columns.push({
        name: "".concat(userPath, "pawn.pawnHash"),
        label: 'Certificate',
        className: 'text-center',
        hideInCsv: true,
        render: function render(_ref10) {
          var value = _ref10.value,
            row = _ref10.row;
          if (!(deployment !== null && deployment !== void 0 && deployment.settings)) {
            return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
          }
          var certificateProps = {
            deploymentId: deploymentId,
            deploymentSettings: deployment.settings,
            actingPawnId: row["".concat(pawnIdPath, "pawnId")],
            actingPawnHash: row["".concat(pawnIdPath, "pawnHash")]
          };
          switch (deploymentType) {
            case 'known':
              certificateProps.language = row['pawn.assignmentProgress.language'];
              break;
            case 'anon':
              certificateProps.language = row.language;
              certificateProps.actingPawnHash = row['pawn.pawn.pawnHash'];
              break;
            case 'group':
              certificateProps.language = row['assignmentProgress.language'];
              break;
            default:
          }
          return /*#__PURE__*/_react["default"].createElement(_index["default"], _extends({}, certificateProps, {
            deploymentType: deploymentType,
            row: row,
            renderCertificate: _this.props.renderCertificate
          }));
        }
      });
    });
    _defineProperty(_this, "addModuleStatusColumns", function (columns) {
      var _this$props4 = _this.props,
        assignment = _this$props4.assignment,
        modules = _this$props4.modules;
      var _this$state5 = _this.state,
        userPath = _this$state5.userPath,
        deploymentType = _this$state5.deploymentType;
      var _iterator3 = _createForOfIteratorHelper(modules),
        _step3;
      try {
        var _loop = function _loop() {
          var m = _step3.value;
          var label = "Module ".concat(m.id);
          if (m.title && m.header) {
            label = "".concat(m.header, ": ").concat(m.title);
          } else if (m.title) {
            label = m.title;
          } else if (m.header) {
            label = m.header;
          }
          columns.push({
            name: "".concat(userPath, "moduleProgressStatus.assignment").concat(assignment.assignmentId, "_module").concat(m.id),
            label: label,
            sort: true,
            filter: true,
            filterSettings: {
              type: 'selectbox',
              placeholder: '-- Choose one --',
              options: [{
                label: STATUS_MAP[0],
                value: 0
              }, {
                label: STATUS_MAP[1],
                value: 1
              }, {
                label: STATUS_MAP[2],
                value: 2
              }]
            },
            render: function render(_ref11) {
              var value = _ref11.value,
                row = _ref11.row;
              if (value > 0) {
                var lastVisitKey = '';
                switch (deploymentType) {
                  case 'anon':
                  case 'known':
                    lastVisitKey = "pawn.moduleProgressStatus.assignment".concat(assignment.assignmentId, "_module").concat(m.id, "_lastVisit");
                    break;
                  case 'group':
                  default:
                    lastVisitKey = "moduleProgressStatus.assignment".concat(assignment.assignmentId, "_module").concat(m.id, "_lastVisit");
                }
                return /*#__PURE__*/_react["default"].createElement("div", null, STATUS_MAP[Number.parseInt(value, 10)], /*#__PURE__*/_react["default"].createElement("br", null), row[lastVisitKey]);
              }
              return STATUS_MAP[0];
            }
          });
        };
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    });
    _defineProperty(_this, "addSurveyStatusColumns", function (columns) {
      var surveys = _this.props.surveys;
      var _this$state6 = _this.state,
        userPath = _this$state6.userPath,
        deploymentType = _this$state6.deploymentType;
      var uniqueHandles = (0, _sortBy2["default"])((0, _uniqBy2["default"])(surveys.filter(function (s) {
        return !s.archived;
      }), 'surveyHandle'), 'position');
      var _iterator4 = _createForOfIteratorHelper(uniqueHandles),
        _step4;
      try {
        var _loop2 = function _loop2() {
          var s = _step4.value;
          columns.push({
            name: "".concat(userPath, "surveyProgressStatus.").concat(s.surveyHandle),
            label: s.label,
            sort: true,
            filter: true,
            filterSettings: {
              type: 'selectbox',
              placeholder: '-- Choose one --',
              options: [{
                label: STATUS_MAP[0],
                value: 0
              }, {
                label: STATUS_MAP[1],
                value: 1
              }, {
                label: STATUS_MAP[2],
                value: 2
              }]
            },
            render: function render(_ref12) {
              var value = _ref12.value,
                row = _ref12.row;
              if (value > 0) {
                var lastVisitKey = '';
                switch (deploymentType) {
                  case 'anon':
                  case 'known':
                    lastVisitKey = "pawn.surveyProgressStatus.".concat(s.surveyHandle, "_lastVisit");
                    break;
                  case 'group':
                  default:
                    lastVisitKey = "surveyProgressStatus.".concat(s.surveyHandle, "_lastVisit");
                }
                return /*#__PURE__*/_react["default"].createElement("div", null, STATUS_MAP[Number.parseInt(value, 10)], /*#__PURE__*/_react["default"].createElement("br", null), row[lastVisitKey]);
              }
              return STATUS_MAP[0];
            }
          });
        };
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    });
    _defineProperty(_this, "actionModalTitle", function () {
      var selectedDeploymentId = _this.selectedDeploymentId();
      var deployment = _this.props.assignment.deploymentList.find(function (d) {
        return d.deploymentId === selectedDeploymentId;
      });
      var modalTitle = "Modify ".concat(_this.state.selectedRows.length, " progress record(s)");
      if (deployment) {
        modalTitle = "".concat(modalTitle, " of ").concat(deployment.label, " data collection wave");
      }
      return modalTitle;
    });
    return _this;
  }
  _inherits(AssignmentStatusTable, _React$Component);
  return _createClass(AssignmentStatusTable, [{
    key: "componentDidMount",
    value:
    /* /////////////////////////////////////////////////////////////////////////
    // LIFECYCLE METHODS //////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */

    function componentDidMount() {
      this.setDeploymentParams();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // if the list of deployment IDs, surveysWhiteList, or pawnIdWhitelist changed...
      if (!(0, _isEmpty2["default"])((0, _xor2["default"])(prevProps.currentDeploymentIds, this.props.currentDeploymentIds)) || !(0, _isEmpty2["default"])((0, _xor2["default"])(prevProps.surveys, this.props.surveys)) || !(0, _isEmpty2["default"])((0, _xor2["default"])(prevProps.pawnIdWhitelist, this.props.pawnIdWhitelist))) {
        this.setDeploymentParams();
      } else if (prevProps.showBy !== this.props.showBy) {
        this.setGraphQLColumns();
      }
    }
  }, {
    key: "render",
    value:
    /* /////////////////////////////////////////////////////////////////////////
    // RENDER /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */

    function render() {
      var _this2 = this;
      var _this$state7 = this.state,
        columns = _this$state7.columns,
        isLoading = _this$state7.isLoading,
        rowKeyPath = _this$state7.rowKeyPath,
        query = _this$state7.query,
        variables = _this$state7.variables,
        assignmentProgressPath = _this$state7.assignmentProgressPath;
      var _this$props5 = this.props,
        adjustColumns = _this$props5.adjustColumns,
        project = _this$props5.project,
        customQuery = _this$props5.customQuery,
        customQueryVariables = _this$props5.customQueryVariables;
      if (isLoading || !query) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true
        });
      }
      var modalTitle = this.actionModalTitle();
      var isCanClearMetrics = Fortress.hasAnyAccess(['quest.modify_data', 'quest.admin'], project.groupId);
      var setRowClass = function setRowClass(row) {
        return row.status === 'flagged' ? _style["default"].unresolved : '';
      };
      return /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
        columns: adjustColumns ? adjustColumns({
          columns: columns
        }) : columns,
        query: customQuery !== null && customQuery !== void 0 ? customQuery : query,
        rowKey: "".concat(rowKeyPath),
        graphqlVariables: customQueryVariables !== null && customQueryVariables !== void 0 ? customQueryVariables : variables,
        csvSaveHeader: true,
        setRowClass: setRowClass,
        striped: false,
        isStickyHeader: true,
        showDoubleScrollbar: true,
        keepSelectedOnFiltering: true,
        rowSelectedCallback: function rowSelectedCallback(selectedRows, data) {
          if (selectedRows.length !== _this2.state.selectedRows.length) {
            _this2.setState(function (prevState) {
              var selectedData = prevState.selectedData;
              var added = (0, _difference2["default"])(selectedRows, _this2.state.selectedRows);
              var removed = (0, _difference2["default"])(_this2.state.selectedRows, selectedRows);
              added.forEach(function (id) {
                selectedData[id] = data.find(function (item) {
                  return item["".concat(rowKeyPath)] === id;
                });
              });
              removed.forEach(function (id) {
                delete selectedData[id];
              });
              return {
                selectedRows: selectedRows,
                selectedData: selectedData
              };
            });
          }
        },
        rowActions: isCanClearMetrics && [{
          name: 'Clear Progress and Metrics',
          title: 'Clear Progress and Metrics',
          inModal: true,
          size: 'large',
          modalTitle: modalTitle,
          component: function component(props) {
            return /*#__PURE__*/_react["default"].createElement(_ClearProgressAndMetrics["default"], _extends({}, props, {
              project: project,
              selectedData: _this2.state.selectedData,
              assignmentProgressPath: assignmentProgressPath
            }));
          }
        }]
      });
    }
  }]);
}(_react["default"].Component);
_defineProperty(AssignmentStatusTable, "propTypes", {
  // from redux state
  assignment: _propTypes["default"].object,
  currentDeploymentIds: _propTypes["default"].array,
  currentDeployments: _propTypes["default"].array,
  pawnIdWhitelist: _propTypes["default"].arrayOf(_propTypes["default"].number),
  project: _propTypes["default"].object,
  projectDeployments: _propTypes["default"].array,
  surveys: _propTypes["default"].array,
  modules: _propTypes["default"].array,
  showBy: _propTypes["default"].string.isRequired,
  hideSystemId: _propTypes["default"].bool,
  // From ExportStatus
  renderCertificate: _propTypes["default"].func,
  setColumnDefinitions: _propTypes["default"].func,
  flagId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
  overrideDeploymentIds: _propTypes["default"].array,
  adjustColumns: _propTypes["default"].func,
  hideResolveAction: _propTypes["default"].bool,
  roleHandles: _propTypes["default"].arrayOf(_propTypes["default"].string),
  customQuery: _propTypes["default"].object,
  customQueryVariables: _propTypes["default"].object
});
_defineProperty(AssignmentStatusTable, "defaultProps", {
  // from redux state
  assignment: {},
  projectDeployments: [],
  currentDeploymentIds: [],
  hideSystemId: false,
  renderCertificate: null,
  setColumnDefinitions: null
});
var mapStateToProps = function mapStateToProps(state, props) {
  var surveyHandleWhitelist = props.surveyHandleWhitelist;
  var surveys = (0, _admin.getCurrentAssignmentSurveys)(state.assignment.admin);
  if (Array.isArray(surveyHandleWhitelist)) {
    surveys = surveys.filter(function (survey) {
      return surveyHandleWhitelist.includes(survey.surveyHandle);
    });
  }
  return {
    assignment: (0, _admin.getCurrentAssignment)(state.assignment.admin),
    currentDeploymentIds: state.assignment.admin.currentDeploymentIds,
    currentDeployments: (0, _admin.getCurrentDeployments)(state.assignment.admin),
    project: (0, _admin.getCurrentProject)(state.assignment.admin),
    projectDeployments: (0, _admin.getCurrentProjectDeployments)(state.assignment.admin),
    surveys: surveys
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(AssignmentStatusTable);